export default __webpack_public_path__ + "static/media/genericFileIcon.ed5a2187.svg";